import * as React from "react";
import { observer } from "mobx-react";
import { MDBBtn, MDBCol } from "mdbreact";
import { Alert, Button, Classes, FormGroup, H5, HTMLSelect, InputGroup, Intent, Popover, TextArea } from "@blueprintjs/core";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { toast } from "react-toastify";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";
import { newISaidaCFOP } from "../../model";
import { Pager } from "../utils/Pager";
import { observable } from "mobx";

const InputMask = require("react-input-mask");

@observer
export default class CfopSaida extends React.Component<{}, {}> {

    obs = observable({
        open_adiciona_cfop_saida: false as boolean,
        open_adiciona_cfops_entrada: false as boolean,
        open_adiciona_cst_entrada: false as boolean
    })

    constructor(props: any) {
        super(props);
    }

    async handleBuscaCFOPSaida(e) {
        SpedEfdStore.obs.input_cfop_saida = e
        let data = e?.replace(/\_/g, "").replace(/\-/g, "")

        if (data.length == 4) {
            let validaCFOP = await SpedEfdStore.cfopsCadastrados(SpedEfdStore.obs.tab_entrada_saida, SpedEfdStore.obs.config_id);

            if (validaCFOP.indexOf(data) > -1) {
                toast.warning('CFOP já cadastrado', {});
                return;
            }

            await SpedEfdStore.handleBuscaCfopSaida(e)
        }
    }

    async handleBuscaCFOPEntrada(e) {
        SpedEfdStore.obs.input_cfop_entrada = e
        let data = e?.replace(/\_/g, "").replace(/\-/g, "")

        if (data.length == 4) {
            await SpedEfdStore.handleBuscaCfopsEntrada(e)
        }
    }

    async handleSaveCfopSaida() {

        let copy2 = Object.assign({}, SpedEfdStore.obs.cfop_saida)

        copy2.cfop_saida = SpedEfdStore.obs.cfop_saida.cfop_saida.codigo ? SpedEfdStore.obs.cfop_saida.cfop_saida.codigo : SpedEfdStore.obs.cfop_saida.cfop_saida
        copy2.cfops_entrada = SpedEfdStore.obs.cfop_saida.cfops_entrada?.map(x => x.codigo)
        copy2.csts_selecionados = SpedEfdStore.obs.cfop_saida.csts_selecionados?.map(x => x.codigo)
        copy2.config_id = SpedEfdStore.obs.config_id

        if (copy2.cfop_saida == "") {
            toast.warning('CFOP de Saída Obrigatório!', {});
            return;
        }

        if (copy2.cfops_entrada.length == 0) {
            toast.warning('Adicione pelo menos um CFOP de Entrada', {});
            return;
        }

        if (copy2.cst_entrada == "selecione") {
            if (copy2.csts_selecionados.length == 0) {
                toast.warning('Selecione um CST ou mude para Todos', {});
                return;
            }
        }
        if (!SpedEfdStore.obs.isEdit) {
            await SpedEfdStore.handleSaveCfop(copy2)
        } else {
            await SpedEfdStore.handleUpdateCfop(copy2)
        }
    }

    handleAdicionaCFOPEntrada() {
        this.obs.open_adiciona_cfops_entrada = false
    }

    handleAdicionaCST() {
        this.obs.open_adiciona_cst_entrada = false
    }

    async handleInserirCFOP() {
        let cfop_entrada = SpedEfdStore.obs.input_cfop_entrada?.replace(/\-/g, "").replace(/\_/g, "")

        if (cfop_entrada == "") {
            toast.warning('CFOP Inválido', {});
            return;
        }

        let validaCFOP = SpedEfdStore.obs.cfop_saida.cfops_entrada?.map(value => {
            return value.codigo;
        });

        if (validaCFOP.indexOf(cfop_entrada) > -1) {
            toast.warning('CFOP já cadastrado', {});
            return;
        } else {
            SpedEfdStore.obs.cfop_saida.cfops_entrada = [...SpedEfdStore.obs.cfop_saida.cfops_entrada, { codigo: cfop_entrada, descricao: SpedEfdStore.obs.cfop_entrada_descricao }];
            toast.success('CFOP inserido com sucesso', {});
            SpedEfdStore.obs.input_cfop_entrada = ""
            SpedEfdStore.obs.cfop_entrada_descricao = ""
            SpedEfdStore.obs.cfops_selecionados = SpedEfdStore.obs.cfop_saida.cfops_entrada?.map(value => {
                return value.codigo;
            });
        }
    }

    hanldeDeleteRowCFOP(codigo: string) {
        SpedEfdStore.obs.cfop_saida.cfops_entrada = SpedEfdStore.obs.cfop_saida.cfops_entrada.filter(
            (item: any) => {
                return item.codigo != codigo;
            },
        );
        SpedEfdStore.obs.cfops_selecionados = SpedEfdStore.obs.cfop_saida.cfops_entrada?.map(value => {
            return value.codigo;
        });
    }

    async handleInserirCST() {
        if (SpedEfdStore.obs.cst == 'selecione') {
            toast.warning('Selecione um CST', {});
            return
        }

        let cst = SpedEfdStore.obs.cst.split("-")[1].replace(/\ /g, "")
        let cst_descricao = SpedEfdStore.obs.cst.split("-")[2]

        let validaCST = SpedEfdStore.obs.cfop_saida.csts_selecionados?.map(value => {
            return value.codigo;
        });

        if (validaCST.indexOf(cst) > -1) {
            toast.warning('CST já cadastrado', {});
            return;
        } else {
            SpedEfdStore.obs.cfop_saida.csts_selecionados = [...SpedEfdStore.obs.cfop_saida.csts_selecionados, { codigo: cst, descricao: cst_descricao }];
            toast.success('CST inserido com sucesso', {});
            SpedEfdStore.obs.cst = 'selecione'
            SpedEfdStore.obs.csts_selecionados = SpedEfdStore.obs.cfop_saida.csts_selecionados?.map(value => {
                return value.codigo;
            });
        }
    }

    hanldeDeleteRowCST(codigo: string) {
        SpedEfdStore.obs.cfop_saida.csts_selecionados = SpedEfdStore.obs.cfop_saida.csts_selecionados.filter(
            (item: any) => {
                return item.codigo != codigo;
            },
        );
        SpedEfdStore.obs.csts_selecionados = SpedEfdStore.obs.cfop_saida.csts_selecionados?.map(value => {
            return value.codigo;
        });
    }

    handleSelectCSTs(e) {
        SpedEfdStore.obs.cfop_saida.cst_entrada = e
        if (e == "todos") {
            SpedEfdStore.obs.cfop_saida.csts_selecionados = []
        }
    }

    async handleEditCFOPSaida(row: any) {
        SpedEfdStore.obs.isEdit = true

        SpedEfdStore.obs.cfop_saida = row
        SpedEfdStore.obs.input_cfop_saida = row.cfop_saida.codigo
        SpedEfdStore.obs.cfop_saida_descricao = row.cfop_saida.descricao

        SpedEfdStore.obs.cfops_selecionados = row.cfops_entrada?.map(value => value.codigo)
        SpedEfdStore.obs.csts_selecionados = row.csts_selecionados?.map(value => value.codigo)

        this.obs.open_adiciona_cfop_saida = true
    }

    async handleClose() {
        SpedEfdStore.obs.input_cfop_saida = ""
        SpedEfdStore.obs.input_cfop_entrada = ""
        SpedEfdStore.obs.cfop_saida_descricao = ""
        SpedEfdStore.obs.cfop_entrada_descricao = ""
        SpedEfdStore.obs.cfops_selecionados = ""
        SpedEfdStore.obs.csts_selecionados = ""
        SpedEfdStore.obs.cst = "selecione"
        SpedEfdStore.obs.cfop_saida = newISaidaCFOP()
        await SpedEfdStore.loadCfops(SpedEfdStore.obs.tab_entrada_saida, 1, SpedEfdStore.obs.config_id);
        SpedEfdStore.obs.cfops_current = 1
        SpedEfdStore.obs.isEdit = false
        this.obs.open_adiciona_cfop_saida = false
    }

    handleChangePage(e: any) {
        SpedEfdStore.loadCfops("saida", SpedEfdStore.obs.cfops_current, SpedEfdStore.obs.config_id)
    }

    handleIncluirCfopSaida() {
        SpedEfdStore.obs.isEdit = false
        this.obs.open_adiciona_cfop_saida = true
    }

    render() {

      if(SpedEfdStore.obs.selectedEmpresa.cfop_calculo_sped){

        return this.renderAutomatico()

      }

      return this.renderNormal()

    }

    renderAutomatico() {
      
      return (
        
        <MDBCol>
        
        <h5>CFOP Cálculo Automático Ativado!</h5>
        
        </MDBCol>

      )

    }

    renderNormal() {

        const formaterDetalhes = (cell, row) => {
            return (
                <>
                    <MDBBtn color="default" rounded size="sm" onClick={() => this.handleEditCFOPSaida(row.items)}>
                        <img src="/images/configuration.png" width={25} />
                    </MDBBtn>

                    <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                        <MDBBtn color="default" rounded size="sm">
                            <img src="/images/bin.png" width={25} />
                        </MDBBtn>
                        <div>
                            <H5>Confirmar exclusão</H5>
                            <p style={{ fontSize: 12 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: 15,
                                }}
                            >
                                <Button
                                    className={Classes.POPOVER_DISMISS}
                                    style={{ marginRight: 10 }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    intent="danger"
                                    className={Classes.POPOVER_DISMISS}
                                    onClick={() => SpedEfdStore.handleDeleteCfop(row.id, row.codigo, row.cfops_entrada)}
                                >
                                    Excluir
                                </Button>
                            </div>
                        </div>
                    </Popover>

                </>
            )
        }

        const formatterRowDeleteCFOPEntrada = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => this.hanldeDeleteRowCFOP(row.codigo)}>
                    <img src="/images/bin.png" width={25} />
                </MDBBtn>
            )
        }

        const formatterRowDeleteCST = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => this.hanldeDeleteRowCST(row.codigo)}>
                    <img src="/images/bin.png" width={25} />
                </MDBBtn>
            )
        }

        let cstOptions = SpedEfdStore.obs.index_csts?.map((value: any) => {
            return (
                <option value={`${value.id} - ${value.codigo} - ${value.descricao}`}>
                    {`${value.codigo} - ${value.descricao}`}
                </option>
            )
        }
        );

        cstOptions.unshift(
            <option value={"selecione"}>{"Selecione o CST"}</option>
        );

        let cfop_saida = SpedEfdStore.obs.index_cfops?.map(obj => {
            return (
                {
                    id: obj.id || obj._id,
                    codigo: obj.cfop_saida?.codigo || obj.cfop_saida?.map(value => value.codigo),
                    descricao: obj.cfop_saida?.descricao,
                    cfops_entrada: obj.cfops_entrada?.map(value => value.codigo),
                    cst_entrada: obj.cst_entrada,
                    csts_selecionados: obj.csts_selecionados?.map(value => value.codigo),
                    items: obj
                }
            );
        })

        return (
            <>
                <MDBCol>
                    <MDBBtn
                        className="btnDefault btnBuscarNfe"
                        style={{ marginRight: 20, float: "left", marginBottom: 20 }}
                        onClick={() => this.handleIncluirCfopSaida()}
                    >
                        Incluir
                    </MDBBtn>

                    <BootstrapTable
                        data={cfop_saida}
                    >
                        <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                        <TableHeaderColumn dataField="codigo" width="15%">CFOP saídas</TableHeaderColumn>
                        <TableHeaderColumn dataField="descricao" width="70%">Descrição</TableHeaderColumn>
                        <TableHeaderColumn dataField="cfops_entrada" width="20%">CFOPs entradas</TableHeaderColumn>
                        <TableHeaderColumn dataField="cst_entrada" width="20%">CSTs entradas</TableHeaderColumn>
                        <TableHeaderColumn dataField="csts_selecionados" width="20%">CSTs selecionados</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={formaterDetalhes} width="15%"></TableHeaderColumn>
                    </BootstrapTable>
                </MDBCol>

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                    <Pager
                        currentPage={SpedEfdStore.obs.cfops_current}
                        totalCount={SpedEfdStore.obs.cfops_length}
                        pageSize={5}
                        onPageChange={(page) => this.handleChangePage(SpedEfdStore.obs.cfops_current = page)}
                    />
                </div>

                <Alert
                    cancelButtonText="Cancelar"
                    confirmButtonText={"Salvar"}
                    isOpen={this.obs.open_adiciona_cfop_saida}
                    onClose={() => this.handleClose()}
                    onConfirm={() => this.handleSaveCfopSaida()}
                    canOutsideClickCancel={true}
                    className="AlertUser"
                    intent={Intent.PRIMARY}
                >
                    {!SpedEfdStore.obs.isEdit ?
                        <h2 className="titleSEFAZ">Adicionar CFOP</h2>
                        :
                        <h2 className="titleSEFAZ">Editar CFOP</h2>
                    }

                    <FormGroup label="CFOP Saída">
                        <InputMask
                            mask="9-999"
                            value={SpedEfdStore.obs.input_cfop_saida}
                            className={SpedEfdStore.obs.isEdit ? "form-control inputDisabled" : "form-control"}
                            onChange={(e) => this.handleBuscaCFOPSaida(e.target.value)}
                            disabled={SpedEfdStore.obs.isEdit}
                        />
                    </FormGroup>

                    <FormGroup label="Descrição">
                        <TextArea style={{ width: "100%" }} disabled value={SpedEfdStore.obs.cfop_saida_descricao} />
                    </FormGroup>

                    <div style={{ display: "flex" }}>
                        <div style={{ width: "90%" }}>
                            <FormGroup label="CFOPs Entrada">
                                <InputGroup disabled value={SpedEfdStore.obs.cfops_selecionados} />
                            </FormGroup>
                        </div>
                        <div style={{ width: "10%", textAlign: "center", marginTop: "25px" }}>
                            <MDBBtn color="default" size="sm" onClick={() => this.obs.open_adiciona_cfops_entrada = true}>
                                <img src="/images/configuration.png" width={25} />
                            </MDBBtn>
                        </div>
                    </div>

                    <FormGroup label="CSTs Entrada">
                        <HTMLSelect
                            onChange={e => this.handleSelectCSTs(e.target.value)}
                            value={SpedEfdStore.obs.cfop_saida.cst_entrada}
                        >
                            <option value="selecione">Selecionar</option>
                            <option value="todos">Todos</option>
                        </HTMLSelect>
                    </FormGroup>

                    <div style={{ display: "flex" }}>
                        <div style={{ width: "90%" }}>
                            <FormGroup label="CSTs Selecionados">
                                <InputGroup disabled value={SpedEfdStore.obs.csts_selecionados} />
                            </FormGroup>
                        </div>

                        <div style={{ width: "10%", textAlign: "center", marginTop: "25px" }}>
                            <MDBBtn color="default" size="sm" onClick={() => this.obs.open_adiciona_cst_entrada = true} disabled={SpedEfdStore.obs.cfop_saida.cst_entrada == "todos"}>
                                <img src="/images/configuration.png" width={25} />
                            </MDBBtn>
                        </div>
                    </div>

                </Alert>

                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Adicionar"
                    isOpen={this.obs.open_adiciona_cfops_entrada}
                    onClose={() => this.obs.open_adiciona_cfops_entrada = false}
                    onConfirm={() => this.handleAdicionaCFOPEntrada()}
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                    className="AlertUser"
                >
                    <div style={{ marginBottom: "60px" }}>

                        <h2 className="titleSEFAZ">Adicionar CFOP Entrada</h2>
                        <div style={{ display: "flex" }}>
                            <FormGroup label="CFOPs Entrada" style={{ width: "200px" }}>
                                <InputMask
                                    mask="9-999"
                                    value={SpedEfdStore.obs.input_cfop_entrada}
                                    className="form-control"
                                    onChange={(e) => this.handleBuscaCFOPEntrada(e.target.value)}
                                />
                            </FormGroup>
                            <div style={{ marginTop: "26px" }}>
                                <MDBBtn className="btnDefault btnBuscarNfe"
                                    onClick={() => this.handleInserirCFOP()}
                                    style={{ marginLeft: 20 }}
                                >
                                    Inserir
                                </MDBBtn>
                            </div>
                        </div>
                        <FormGroup label="Descrição">
                            <TextArea style={{ width: "100%" }} disabled value={SpedEfdStore.obs.cfop_entrada_descricao} />
                        </FormGroup>

                        <BootstrapTable
                            className="dados-recolhimento"
                            data={SpedEfdStore.obs.cfop_saida.cfops_entrada}
                        >
                            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                            <TableHeaderColumn dataField="codigo" width="50%">CFOP Entrada</TableHeaderColumn>
                            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={formatterRowDeleteCFOPEntrada} width="20%"></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Alert>

                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Adicionar"
                    isOpen={this.obs.open_adiciona_cst_entrada}
                    onClose={() => this.obs.open_adiciona_cst_entrada = false}
                    onConfirm={() => this.handleAdicionaCST()}
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                    className="AlertUser"
                >
                    <div style={{ marginBottom: "60px" }}>

                        <h2 className="titleSEFAZ">Adicionar CST</h2>

                        <div style={{ display: "flex" }}>
                            <div style={{ width: "90%" }}>
                                <HTMLSelect
                                    onChange={e => SpedEfdStore.obs.cst = e.target.value}
                                    value={SpedEfdStore.obs.cst}
                                >
                                    {cstOptions}
                                </HTMLSelect>
                            </div>
                            <div>
                                <MDBBtn className="btnDefault btnBuscarNfe"
                                    onClick={() => this.handleInserirCST()}
                                    style={{ marginLeft: 20 }}
                                >
                                    Inserir
                                </MDBBtn>
                            </div>
                        </div>

                        <BootstrapTable
                            className="dados-recolhimento"
                            data={SpedEfdStore.obs.cfop_saida.csts_selecionados}
                        >
                            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                            <TableHeaderColumn dataField="codigo" width="50%">CST</TableHeaderColumn>
                            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={formatterRowDeleteCST} width="20%"></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Alert>
            </>
        )
    }
}